import {useAppSelector} from '../../store/hooks';
import {Redirect} from 'react-router-dom';
import {PropsWithChildren} from 'react';

type EnsurePermissionProps = PropsWithChildren<{
  elementPermissions?: Nullable<string[]>,
  showError?: boolean
}>

const EnsurePermission = ({
  children, elementPermissions = [], showError=false
}: EnsurePermissionProps) => {
  const {permissions: currentUserPermissions} = useAppSelector((state) =>
    state.permissions);

  if (!elementPermissions || !elementPermissions?.length) {
    return <>{children}</>;
  }

  const canBeVisible = elementPermissions
      .some((permission) => currentUserPermissions.includes(permission));

  if (canBeVisible) {
    return <>{children}</>;
  }

  if (showError && currentUserPermissions.length) {
    return <Redirect to="/"/>;
  }

  return null;
};

export default EnsurePermission;
